import React from 'react';

export interface TestimonialProps {
  name: string;
  title?: string;
  quote: string;
}

const Testimonial = ({ name, title, quote }: TestimonialProps) => {
  return (
    <figure className="w-full max-w-full border-0 border-b-[3px] border-solid border-primary-magenta sm:max-w-[300px] md:max-w-[440px]">
      <div className="pull-quote !mb-0 !mt-0 !min-h-[46px] flex-row !pt-0  text-headline-xs before:!-ml-12 before:!max-h-[46px] before:!min-h-[46px] before:!text-[160px] before:leading-[0.8]" />
      <p className="mb-0 mt-16 font-suisse-neue text-body-lg sm:min-h-[135px] md:min-h-[108px]">
        {quote}
      </p>
      <figcaption className="mt-10">
        <span className="text-byline-lg">{name}</span>
        {title && <span className="text-byline-md text-grayscale-charcoal"> | {title}</span>}
      </figcaption>
    </figure>
  );
};

export default Testimonial;
